import { api } from '../../lib/api';
import type { SearchResults } from './types';

/**
 * Search transport.
 *
 * ── ASSUMED CONTRACT ──────────────────────────────────────────────────────
 *   GET /workspaces/:workspaceId/search?q=&limit= -> SearchResults
 *
 * `q` is required and non-empty server-side (see search.dto.ts), so callers
 * must not fire this while the box is empty — `useSearch` enforces that.
 */
export function fetchSearch(
  workspaceId: string,
  q: string,
  limit: number,
  signal?: AbortSignal,
): Promise<SearchResults> {
  const params = new URLSearchParams({ q, limit: String(limit) });
  return api.get<SearchResults>(
    `/workspaces/${encodeURIComponent(workspaceId)}/search?${params.toString()}`,
    signal,
  );
}
